import React from 'react'

import cn from 'classnames'

import { CustomButton, IconInfo } from 'src/components/ui'

import styles from './InfoContainer.module.scss'
import { useVariantsConfig } from './hooks/useVariantsConfig'

interface Props {
  variant: 'ton_wallet' | 'support' | 'go_out'
  status?: 'connected' | 'not_connected'
  className?: string
}

const InfoContainerPage: React.FC<Props> = ({ variant, status, className }) => {
  const VARIANTS_CONFIG = useVariantsConfig()
  const config =
    variant === 'ton_wallet' ? VARIANTS_CONFIG[variant][status || 'not_connected'] : VARIANTS_CONFIG[variant]

  if (!config) return null

  return (
    <div className={cn(styles.container, styles[variant], className)}>
      <IconInfo className={styles.container_icon} name={config.iconName} color='violet' />
      <h1>{config.title}</h1>
      <p className={styles.container_subtitle}>{config.subtitle}</p>
      <CustomButton
        className={styles.container_btn}
        variant='contained'
        color={config.buttonColor}
        opacity={config.buttonOpacity}
      >
        {config.buttonText}
      </CustomButton>
    </div>
  )
}

export default InfoContainerPage
